const ITEMS = [
    "Strategy", "Web Development", "Branding", "Social Media", "Digital Marketing",
    "UI / UX", "SEO", "Creative Direction", "Content Systems", "Growth",
];

function Hex() {
    return (
        <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 shrink-0 text-violet-500" fill="currentColor" aria-hidden="true">
            <polygon points="17.5,5 12,2 6.5,5 6.5,19 12,22 17.5,19" transform="rotate(90 12 12)" />
        </svg>
    );
}

export default function Marquee() {
    const row = (key) => (
        <div key={key} className="flex shrink-0 items-center gap-10 pr-10" aria-hidden={key === "b"}>
            {ITEMS.map((item) => (
                <span key={`${key}-${item}`} className="flex items-center gap-10">
                    <span className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-white/80 whitespace-nowrap">{item}</span>
                    <Hex />
                </span>
            ))}
        </div>
    );
    return (
        <div className="relative border-y border-white/10 bg-[#0C101A] py-6 overflow-hidden" data-testid="editorial-marquee">
            <div className="flex w-max animate-marquee-x">
                {row("a")}
                {row("b")}
            </div>
        </div>
    );
}
